import links from '../../links';

export default {
  title: `The Terms & Conditions have changed, please read them and validate them`,
  text: `I have read and accept without reservation the [Terms & Conditions](${links.legalTerms})`,
  error: `Please agree to the Terms and Conditions`,
  confirm: `Confirm`,
};
